import { useEffect, useRef } from 'react';
let hideUserSupportRefCount = 0;
export default function useHideUserSupportBtn(hide) {
    // Track if this instance has ever contributed to hiding the support button
    const hasContributedToHiding = useRef(false);
    const pollingIntervalRef = useRef(null);
    const getUserSupportWidget = () => {
        var _a, _b;
        // Check for AI Chat Widget first (by ID)
        const aiWidget = document.getElementById('ai-trigger-button');
        if (aiWidget) {
            return aiWidget;
        }
        // Fall back to Intercom widget — check both states:
        // - 'intercom-lightweight-app' is the default launcher state
        // - 'intercom-app' appears after the user has interacted with the widget
        const intercomWidget = ((_a = document.getElementsByClassName('intercom-lightweight-app')) === null || _a === void 0 ? void 0 : _a[0]) ||
            ((_b = document.getElementsByClassName('intercom-app')) === null || _b === void 0 ? void 0 : _b[0]);
        return intercomWidget || null;
    };
    const applyWidgetVisibility = (widget) => {
        if (hideUserSupportRefCount > 0) {
            widget.style.visibility = 'hidden';
        }
        else {
            widget.style.visibility = 'visible';
        }
    };
    const startPollingForWidget = () => {
        if (pollingIntervalRef.current)
            return; // Already polling
        pollingIntervalRef.current = setInterval(() => {
            const widget = getUserSupportWidget();
            if (widget) {
                applyWidgetVisibility(widget);
                // Stop polling once widget is found
                if (pollingIntervalRef.current) {
                    clearInterval(pollingIntervalRef.current);
                    pollingIntervalRef.current = null;
                }
            }
        }, 5000);
    };
    const stopPolling = () => {
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
        }
    };
    useEffect(() => {
        const supportWidget = getUserSupportWidget();
        if (hide) {
            // Only increment if this instance hasn't contributed before
            if (!hasContributedToHiding.current) {
                hideUserSupportRefCount += 1;
                hasContributedToHiding.current = true;
            }
            if (supportWidget) {
                supportWidget.style.visibility = 'hidden';
            }
            else {
                startPollingForWidget();
            }
        }
        else {
            // Only decrement if this instance was previously contributing to hiding
            if (hasContributedToHiding.current) {
                hideUserSupportRefCount = hideUserSupportRefCount > 0 ? hideUserSupportRefCount - 1 : 0;
                hasContributedToHiding.current = false;
            }
            if (hideUserSupportRefCount === 0 && supportWidget) {
                supportWidget.style.visibility = 'visible';
            }
            else if (!supportWidget) {
                // Start polling to apply visibility when widget becomes available
                startPollingForWidget();
            }
        }
        return () => {
            // Stop polling on cleanup
            stopPolling();
            // Only decrement on cleanup if this instance was contributing to hiding
            if (hasContributedToHiding.current) {
                hideUserSupportRefCount = hideUserSupportRefCount > 0 ? hideUserSupportRefCount - 1 : 0;
                if (hideUserSupportRefCount === 0) {
                    const widget = getUserSupportWidget();
                    if (widget) {
                        widget.style.visibility = 'visible';
                    }
                }
            }
        };
    }, [hide]);
}
